import React from 'react';

import classNames from 'classnames';

import './Tabs.scoped.scss';

interface Tab {
  label: React.ReactNode;
  icon?: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string;
    }
  >;
  id: string;
}

interface Props {
  children?: React.ReactNode;
  tabs: Tab[];
  selectedTabId: string;
  onChange: (tab: Tab) => void;
  fullWidth?: boolean;
  height?: string;
  showBorderBottom?: boolean;
}

const Tabs: React.FC<Props> = ({
  tabs,
  selectedTabId,
  onChange,
  children,
  fullWidth = false,
  height = '68px',
  showBorderBottom,
}) => {
  return (
    <div className="tabs" style={{ borderBottom: showBorderBottom ? '1px solid #e7edf4' : '' }}>
      {tabs.map((tab, index) => {
        const Icon = tab.icon;

        return [
          <div
            key={index}
            onClick={() => onChange(tab)}
            className={classNames(['tab', tab.id === selectedTabId ? 'tabActive' : 'tabInactive'])}
            style={{
              height,

              flexGrow: fullWidth ? 1 : 'initial',
            }}
          >
            <div className="tabInner nowrap">
              {Icon && (
                <div className="iconContainer">
                  <Icon />
                </div>
              )}
              <div className="labelContainer">{tab.label}</div>
            </div>
          </div>,
          <div key="seperator" className="tabSeperator"></div>,
        ];
      })}
      {children}
    </div>
  );
};

export default Tabs;
